












import { Component, Vue } from "vue-property-decorator";

@Component({})
export default class PresetDeleteModal extends Vue {
  show() {
    (this.$refs.modal as any).show();
  }

  hide() {
    (this.$refs.modal as any).hide();
  }

  create() {
    this.$emit("ok");
    this.hide();
  }
}
